import { ExpenditureSubmission } from './ExpenditureFormModal';
import { IncomeSubmission } from './IncomeFormModal';
import { LifeEventSubmission } from './LifeEventFormModal';
import { useSaveGroupedItem } from './useSaveGroupedItem';

export function useSaveIncome(): (submission: IncomeSubmission) => Promise<void> {
  return useSaveGroupedItem<IncomeSubmission['allocations'][number], IncomeSubmission>(
    { collection: 'incomes', queryKey: 'incomes' },
    (allocation, submission, groupId) => ({
      id: allocation.itemId,
      groupId,
      clientId: allocation.clientId,
      description: submission.description,
      frequency: submission.frequency,
      incomeType: submission.incomeType,
      amountPreTax: allocation.amountPreTax,
      amountPostTax: allocation.amountPostTax,
    }),
  );
}

export function useSaveExpenditure(): (submission: ExpenditureSubmission) => Promise<void> {
  return useSaveGroupedItem<ExpenditureSubmission['allocations'][number], ExpenditureSubmission>(
    { collection: 'expenditures', queryKey: 'expenditures' },
    (allocation, submission, groupId) => ({
      id: allocation.itemId,
      groupId,
      clientId: allocation.clientId,
      description: submission.description,
      category: submission.category,
      frequency: submission.frequency,
      amount: allocation.amount,
    }),
  );
}

export function useSaveLifeEvent(): (submission: LifeEventSubmission) => Promise<void> {
  return useSaveGroupedItem<LifeEventSubmission['allocations'][number], LifeEventSubmission>(
    { collection: 'life-events', queryKey: 'life-events' },
    (allocation, submission, groupId) => ({
      id: allocation.itemId,
      groupId,
      clientId: allocation.clientId,
      description: submission.description,
      details: submission.details,
      eventDate: submission.eventDate,
      cost: allocation.cost,
    }),
  );
}
